export default __webpack_public_path__ + "static/RunRight8-fc35d7c25fe2797b137153d7733fcd5e.mp3";